<template>
  <div class="case-digital-mlpa-main-data-info-page col-block width-full">
    <div class="case-digital-mlpa-main-data-info-data-group-container col-block width-full">
      <div
        class="case-digital-mlpa-main-data-info-data-container col-block width-full"
        v-for="key in Object.keys(dataOptions)"
        :key="key"
      >
        <div class="case-digital-mlpa-main-data-info-data-block col-block width-full">
          <div v-if="dataOptions[key].title" class="case-digital-mlpa-main-data-info-data-title-container row-block">
            <div class="case-digital-mlpa-main-data-info-data-title ellipsis">{{ dataOptions[key].title }}</div>
            <div :style="{ flex: 1 }"></div>
          </div>
          <div class="case-digital-mlpa-main-data-info-data-table-container col-block width-full">
            <div class="case-digital-mlpa-main-data-info-data-table-block">
              <div
                class="case-digital-mlpa-main-data-info-data-table-data-container col-block width-full"
                v-for="(option, oindex) in dataOptions[key].options"
                :key="oindex"
                :style="{ '--grid': option.grid || 1 }"
              >
                <div class="case-digital-mlpa-main-data-info-data-table-data-title-container row-block">
                  <div class="case-digital-mlpa-main-data-info-data-table-data-title ellipsis">{{ option.title }}</div>
                  <div :style="{ flex: 1 }"></div>
                </div>
                <div class="case-digital-mlpa-main-data-info-data-table-data-content-container col-block width-full">
                  <div
                    class="case-digital-mlpa-main-data-info-data-table-data-content break-line"
                    :style="(option.style || (() => {}))(infoData)"
                    v-html="option.value(infoData) || '<h5>- -</h5>'"
                  ></div>
                </div>
                <div :style="{ flex: 1 }"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :style="{ height: '15px' }"></div>
    <div class="case-digital-mlpa-main-data-info-table-group-container col-block width-full">
      <div
        class="case-digital-mlpa-main-data-info-table-container col-block width-full"
        v-for="key in Object.keys(tableOptions)"
        :key="key"
      >
        <div class="case-digital-mlpa-main-data-info-table-block col-block width-full">
          <div v-if="tableOptions[key].title" class="case-digital-mlpa-main-data-info-table-title-container row-block">
            <div class="case-digital-mlpa-main-data-info-table-title ellipsis">{{ tableOptions[key].title }}</div>
            <div :style="{ flex: 1 }"></div>
          </div>
          <div class="case-digital-mlpa-main-data-info-table-table-container col-block width-full">
            <div class="case-digital-mlpa-main-data-info-table-table-block">
              <div
                class="case-digital-mlpa-main-data-info-table-table-data-container col-block width-full"
                v-for="(option, oindex) in tableOptions[key].options"
                :key="oindex"
                :style="{ '--grid': option.grid || 1 }"
              >
                <div class="case-digital-mlpa-main-data-info-table-table-data-block title col-block">
                  <div class="case-digital-mlpa-main-data-info-table-table-data-cell-container row-block">
                    <div class="case-digital-mlpa-main-data-info-table-table-data-cell-block shrink ellipsis">{{ option.title }}</div>
                  </div>
                </div>
                <div class="case-digital-mlpa-main-data-info-table-table-data-block content col-block">
                  <div class="case-digital-mlpa-main-data-info-table-table-data-cell-container row-block">
                    <div
                      class="case-digital-mlpa-main-data-info-table-table-data-cell-block shrink ellipsis"
                      :class="{ alert: !option.result }"
                      v-html="$t(option.result ? 'COMPONENT.digitalMLPA.mainDataInfo.table.quality.content.___OK' : 'COMPONENT.digitalMLPA.mainDataInfo.table.quality.content.___Warning')"
                    ></div>
                    <div v-if="Object.keys(option.infos || {}).length" class="case-digital-mlpa-main-data-info-table-table-data-cell-info-container">
                      <borCor
                        :reverse="!((oindex + 1) % 5)"
                        :background="'white'"
                        :border="'#CCCCCC'"
                        :radius="'0px'"
                        :blockStyle="{ padding: '8px' }"
                      >
                        <div slot="trigger">
                          <img :src="require('../../assets/images/case-af-info-icon.svg')" alt="">
                        </div>
                        <div slot="content">
                          <div class="case-digital-mlpa-main-data-info-table-table-data-cell-info-block col-block flex-start">
                            <span
                              class="case-digital-mlpa-main-data-info-table-table-data-cell-info"
                              v-for="key in Object.keys(option.infos || {})"
                              :key="key"
                              :class="{ alert: !option.infos[key] }"
                              v-html="$t(option.infos[key] ? 'COMPONENT.digitalMLPA.mainDataInfo.table.quality.info.___OK' : 'COMPONENT.digitalMLPA.mainDataInfo.table.quality.info.___Failed', { field: key })"
                            ></span>
                          </div>
                        </div>
                      </borCor>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import borCor from '../../components/tool/newBorCor.vue'

export default {
  components: {
    borCor
  },
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  computed: {
    infoData () {
      let view = this.project.views || {}
      return [
        'MetadataView',
        'QualityView'
      ].reduce((data, key) => ({ ...data, ...(view[key] || {}) }), {})
    },
    // static
    dataOptions () {
      return {
        'info': {
          options: [
            // 1
            {
              title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.info.table.Barcode_Name.___title'),
              value: data => data.barcode_name,
              grid: 3
            },
            {
              title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.info.table.Sample_Name.___title'),
              value: data => data.sample_name,
              grid: 3
            },
            {
              title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.info.table.Sample_Type.___title'),
              value: data => data.sample_settings,
              grid: 3
            },
            {
              title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.info.table.Product_Name.___title'),
              value: data => data.product_name,
              grid: 3
            },
            // 2
            {
              title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.info.table.Sheet_Name.___title'),
              value: data => data.sheet_name,
              grid: 3
            },
            {
              title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.info.table.Analyzed_Sex.___title'),
              value: data => ({
                'Male': this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.info.table.Analyzed_Sex.value.___Male'),
                'Female': this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.info.table.Analyzed_Sex.value.___Female')
              }[data.analysed_sex]),
              style: data => ({
                color: {
                  'Male': '#003679',
                  'Female': '#BE0F0F'
                }[data.analysed_sex]
              }),
              grid: 3
            },
            {
              title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.info.table.Analyzed_Panels.___title', { count: (this.infoData.aberrant_panel || []).length }),
              value: data => (data.analyzed_panel || []).map(panel => '<span ' + ((data.aberrant_panel || []).includes(panel) ? 'class="alert bold"' : '') + '>' + panel + '</span>').join(', '),
              grid: 6
            }
          ]
        },
        'quality': {
          title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.quality.___title'),
          options: [
            // 1
            {
              title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.quality.table.Is_Passed.___title'),
              value: data => ({
                'true': this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.quality.table.Is_Passed.value.___Pass'),
                'false': this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.quality.table.Is_Passed.value.___Failed')
              }[data.is_passed]),
              style: data => ({
                color: {
                  'true': '#83C91E',
                  'false': '#FA3D3D'
                }[data.is_passed]
              }),
              grid: 3
            },
            {
              title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.quality.table.Plausible_Root_Cause.___title'),
              value: data => ({
                'NotApplicable': this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.quality.table.Plausible_Root_Cause.value.___NotApplicable')
              }[data.plausible_root_cause] || this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.quality.table.Plausible_Root_Cause.value.___Others')),
              style: data => ({
                color: {
                  'NotApplicable': '#FA3D3D'
                }[data.plausible_root_cause]
              }),
              grid: 3
            },
            {
              title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.quality.table.Plausible_Root_Cause_Description.___title'),
              value: data => ({
                'n/a': this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.quality.table.Plausible_Root_Cause_Description.value.___NA')
              }[data.plausible_root_cause_description] || this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.quality.table.Plausible_Root_Cause_Description.value.___Others')),
              style: data => ({
                color: {
                  'n/a': '#999999'
                }[data.plausible_root_cause_description]
              }),
              grid: 6
            }
          ]
        }
      }
    },
    tableOptions () {
      let tableData = (((this.project.views || {}).QualityView || {}).qualityitem || []).reduce((data, item) => ({
        ...data,
        [item.aspect]: {
          result: !(item.classification === 'OK'),
          infos: (item.children || []).reduce((infos, child) => ({ ...infos, ...(child.aspect ? { [child.aspect]: !(child.classification === 'OK') } : {}) }), {})
        }
      }), {})
      return {
        'quality': {
          options: [
            // 1
            {
              title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.table.quality.title.___Overall'),
              result: tableData['Overall'].result,
              infos: tableData['Overall'].infos,
              grid: 2
            },
            {
              title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.table.quality.title.___Data_Analysis'),
              result: tableData['Data Analysis'].result,
              infos: tableData['Data Analysis'].infos,
              grid: 2
            },
            {
              title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.table.quality.title.___Dna'),
              result: tableData['Dna'].result,
              infos: tableData['Dna'].infos,
              grid: 2
            },
            {
              title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.table.quality.title.___Hybridisation'),
              result: tableData['Hybridisation'].result,
              infos: tableData['Hybridisation'].infos,
              grid: 2
            },
            {
              title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.table.quality.title.___Identity'),
              result: tableData['Identity'].result,
              infos: tableData['Identity'].infos,
              grid: 2
            },
            // 2
            {
              title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.table.quality.title.___Ligase_Activity'),
              result: tableData['Ligase Activity'].result,
              infos: tableData['Ligase Activity'].infos,
              grid: 2
            },
            {
              title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.table.quality.title.___Ligation'),
              result: tableData['Ligation'].result,
              infos: tableData['Ligation'].infos,
              grid: 2
            },
            {
              title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.table.quality.title.___Polymerase'),
              result: tableData['Polymerase'].result,
              infos: tableData['Polymerase'].infos,
              grid: 2
            },
            {
              title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.table.quality.title.___Program'),
              result: tableData['Program'].result,
              infos: tableData['Program'].infos,
              grid: 2
            },
            {
              title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.table.quality.title.___Sample_Run'),
              result: tableData['Sample Run'].result,
              infos: tableData['Sample Run'].infos,
              grid: 2
            }
          ]
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/digitalMLPA/mainDataInfo.vue